import { render, staticRenderFns } from "./bulk-messages.vue?vue&type=template&id=b1d768ba"
import script from "./bulk-messages.vue?vue&type=script&lang=js"
export * from "./bulk-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports